import { cn } from "../../lib/utils.ts";

export const GoogleCalendarIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      role="img"
      aria-label="Google Calendar"
      className={cn(className)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#google-calendar-clip)">
        <path
          d="M0 5.68889C0 3.69759 0 2.70194 0.484415 1.94137C0.910519 1.27235 1.59043 0.728415 2.42671 0.387532C3.37743 0 4.62199 0 7.11111 0H12.8889C15.378 0 16.6226 0 17.5733 0.387532C18.4096 0.728415 19.0895 1.27235 19.5156 1.94137C20 2.70194 20 3.69759 20 5.68889V10.3111C20 12.3024 20 13.2981 19.5156 14.0586C19.0895 14.7277 18.4096 15.2716 17.5733 15.6125C16.6226 16 15.378 16 12.8889 16H7.11111C4.62199 16 3.37743 16 2.42671 15.6125C1.59043 15.2716 0.910519 14.7277 0.484415 14.0586C0 13.2981 0 12.3024 0 10.3111V5.68889Z"
          fill="white"
        />
        <path
          d="M18.4925 0H15.2412V4.71125H19.9987V1.32845C19.9987 1.32845 19.7636 0.128477 18.4925 0Z"
          fill="#1967D2"
        />
        <path
          d="M15.2426 19.978V19.9895V19.9998L20 15.2886H19.9574L15.2426 19.978Z"
          fill="#1967D2"
        />
        <path d="M19.9996 15.2883V15.2461L19.9574 15.2883H19.9996Z" fill="#FBBC05" />
        <path d="M20 4.71143H15.2426V15.2465H20V4.71143Z" fill="#FBBC05" />
        <path d="M19.9574 15.2886H15.2426V19.978L19.9574 15.2886Z" fill="#EA4335" />
        <path d="M15.2426 15.2883H19.9574L20 15.2461H15.2426V15.2883Z" fill="#EA4335" />
        <path d="M15.231 19.9895H15.2425V19.978L15.231 19.9895Z" fill="#34A853" />
        <path d="M4.65027 15.2461V19.9895H15.2309L15.2425 15.2461H4.65027Z" fill="#34A853" />
        <path d="M15.2425 15.2885V15.2461L15.231 19.9895L15.2425 19.9779V15.2885Z" fill="#34A853" />
        <path
          d="M0 15.2461V18.5441C0.0426274 19.6143 1.20002 19.9895 1.20002 19.9895H4.65026V15.2461H0Z"
          fill="#188038"
        />
        <path
          d="M4.65026 4.71125H15.2425V0H1.33437C1.33437 0 0.0852548 0.128477 0 1.45564V15.2464H4.65026V4.71125Z"
          fill="#4285F4"
        />
        <path
          d="M8.11563 13.114C7.8733 13.114 7.63962 13.0824 7.4146 13.0193C7.19535 12.9562 6.99341 12.8615 6.80878 12.7352C6.62414 12.6032 6.45971 12.4397 6.31546 12.2446C6.17699 12.0495 6.07025 11.8228 5.99524 11.5645L7.05976 11.1428C7.13477 11.4297 7.2617 11.6478 7.44057 11.797C7.61943 11.9404 7.84445 12.0122 8.11563 12.0122C8.23679 12.0122 8.35219 11.9949 8.46182 11.9605C8.57144 11.9203 8.66664 11.8658 8.74742 11.797C8.8282 11.7281 8.89166 11.6478 8.93782 11.5559C8.98975 11.4584 9.01571 11.3493 9.01571 11.2288C9.01571 10.9763 8.92051 10.7784 8.73011 10.6349C8.54548 10.4914 8.28872 10.4197 7.95985 10.4197H7.44922V9.39534H7.91657C8.03197 9.39534 8.14448 9.381 8.2541 9.3523C8.36373 9.32361 8.45893 9.28057 8.53971 9.22318C8.62625 9.16006 8.69261 9.08259 8.73876 8.99077C8.79069 8.89321 8.81666 8.78131 8.81666 8.65506C8.81666 8.45994 8.74742 8.30213 8.60894 8.18162C8.47047 8.05537 8.28295 7.99225 8.04639 7.99225C7.79252 7.99225 7.59635 8.06111 7.45788 8.19884C7.32517 8.33083 7.23285 8.48003 7.18093 8.64645L6.14237 8.22466C6.1943 8.08119 6.27219 7.93486 6.37604 7.78566C6.4799 7.63071 6.60972 7.49298 6.7655 7.37247C6.92706 7.24622 7.11457 7.1458 7.32806 7.07119C7.54154 6.99085 7.78675 6.95068 8.0637 6.95068C8.34642 6.95068 8.60317 6.99085 8.83397 7.07119C9.07053 7.15154 9.27247 7.26344 9.43979 7.40691C9.60711 7.54463 9.73693 7.71105 9.82925 7.90617C9.92157 8.09554 9.96773 8.30213 9.96773 8.52594C9.96773 8.6981 9.94465 8.85304 9.89849 8.99077C9.8581 9.1285 9.80329 9.25188 9.73405 9.36091C9.66481 9.46994 9.58404 9.56463 9.49172 9.64497C9.40517 9.71958 9.31574 9.77983 9.22343 9.82574V9.8946C9.50037 10.0036 9.72828 10.1787 9.90714 10.4197C10.0918 10.6607 10.1841 10.9649 10.1841 11.3321C10.1841 11.5904 10.135 11.8285 10.037 12.0466C9.93888 12.2589 9.79752 12.4454 9.61288 12.6061C9.43402 12.7668 9.21766 12.8902 8.96379 12.9763C8.70992 13.0681 8.4272 13.114 8.11563 13.114Z"
          fill="#4285F4"
        />
        <path
          d="M12.2509 12.9763V8.41404L11.2037 8.85304L10.7882 7.89756L12.5278 7.08841H13.3846V12.9763H12.2509Z"
          fill="#4285F4"
        />
      </g>
      <defs>
        <clipPath id="google-calendar-clip">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
